import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_soustitre_1Texte, id_soustitre_1CouleurTexte, id_soustitre_1Opacite, id_soustitre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_card_1_icon_1Id, id_card_1_icon_1Alt, id_card_1_icon_1Opacite, id_card_1_icon_1Afficher, id_card_1_titre_1Texte, id_card_1_titre_1CouleurTexte, id_card_1_titre_1Opacite, id_card_1_titre_1Afficher, id_card_1_paragraphe_1Texte, id_card_1_paragraphe_1CouleurTexte, id_card_1_paragraphe_1Opacite, id_card_1_paragraphe_1Afficher, id_card_1_bouton_1Texte, id_card_1_bouton_1Url, id_card_1_bouton_1CouleurFond, id_card_1_bouton_1CouleurTexte, id_card_1_bouton_1CouleurBordure, id_card_1_bouton_1CouleurFondHover, id_card_1_bouton_1CouleurTexteHover, id_card_1_bouton_1CouleurBordureHover, id_card_1_bouton_1CouleurFondActive, id_card_1_bouton_1CouleurTexteActive, id_card_1_bouton_1CouleurBordureActive, id_card_1_bouton_1Opacite, id_card_1_bouton_1Afficher, id_card_1_bouton_1_texteTexte, id_card_1_bouton_1_texteCouleurTexte, id_card_1_bouton_1_texteOpacite, id_card_1_bouton_1_texteAfficher, id_card_2_icon_1Id, id_card_2_icon_1Alt, id_card_2_icon_1Opacite, id_card_2_icon_1Afficher, id_card_2_titre_1Texte, id_card_2_titre_1CouleurTexte, id_card_2_titre_1Opacite, id_card_2_titre_1Afficher, id_card_2_paragraphe_1Texte, id_card_2_paragraphe_1CouleurTexte, id_card_2_paragraphe_1Opacite, id_card_2_paragraphe_1Afficher, id_card_2_bouton_1Texte, id_card_2_bouton_1Url, id_card_2_bouton_1CouleurFond, id_card_2_bouton_1CouleurTexte, id_card_2_bouton_1CouleurBordure, id_card_2_bouton_1CouleurFondHover, id_card_2_bouton_1CouleurTexteHover, id_card_2_bouton_1CouleurBordureHover, id_card_2_bouton_1CouleurFondActive, id_card_2_bouton_1CouleurTexteActive, id_card_2_bouton_1CouleurBordureActive, id_card_2_bouton_1Opacite, id_card_2_bouton_1Afficher, id_card_2_bouton_1_texteTexte, id_card_2_bouton_1_texteCouleurTexte, id_card_2_bouton_1_texteOpacite, id_card_2_bouton_1_texteAfficher, id_card_3_icon_1Id, id_card_3_icon_1Alt, id_card_3_icon_1Opacite, id_card_3_icon_1Afficher, id_card_3_titre_1Texte, id_card_3_titre_1CouleurTexte, id_card_3_titre_1Opacite, id_card_3_titre_1Afficher, id_card_3_paragraphe_1Texte, id_card_3_paragraphe_1CouleurTexte, id_card_3_paragraphe_1Opacite, id_card_3_paragraphe_1Afficher, id_card_3_bouton_1Texte, id_card_3_bouton_1Url, id_card_3_bouton_1CouleurFond, id_card_3_bouton_1CouleurTexte, id_card_3_bouton_1CouleurBordure, id_card_3_bouton_1CouleurFondHover, id_card_3_bouton_1CouleurTexteHover, id_card_3_bouton_1CouleurBordureHover, id_card_3_bouton_1CouleurFondActive, id_card_3_bouton_1CouleurTexteActive, id_card_3_bouton_1CouleurBordureActive, id_card_3_bouton_1Opacite, id_card_3_bouton_1Afficher, id_card_3_bouton_1_texteTexte, id_card_3_bouton_1_texteCouleurTexte, id_card_3_bouton_1_texteOpacite, id_card_3_bouton_1_texteAfficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_card_1_icon_1ImageUrl, id_card_2_icon_1ImageUrl, id_card_3_icon_1ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_card_1_icon_1ImageUrl: id_card_1_icon_1Id ? media.getMedia( id_card_1_icon_1Id )?.source_url : null,
            id_card_2_icon_1ImageUrl: id_card_2_icon_1Id ? media.getMedia( id_card_2_icon_1Id )?.source_url : null,
            id_card_3_icon_1ImageUrl: id_card_3_icon_1Id ? media.getMedia( id_card_3_icon_1Id )?.source_url : null
        };
    }, [ blocImageFondId, id_card_1_icon_1Id, id_card_2_icon_1Id, id_card_3_icon_1Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{`
        .id_card_1_bouton_1:hover {
            background-color: ${id_card_1_bouton_1CouleurFondHover} !important;
            color: ${id_card_1_bouton_1CouleurTexteHover} !important;
            border-color: ${id_card_1_bouton_1CouleurBordureHover} !important;
        }
        .id_card_1_bouton_1:active {
            background-color: ${id_card_1_bouton_1CouleurFondActive} !important;
            color: ${id_card_1_bouton_1CouleurTexteActive} !important;
            border-color: ${id_card_1_bouton_1CouleurBordureActive} !important;
        }
        .id_card_2_bouton_1:hover {
            background-color: ${id_card_2_bouton_1CouleurFondHover} !important;
            color: ${id_card_2_bouton_1CouleurTexteHover} !important;
            border-color: ${id_card_2_bouton_1CouleurBordureHover} !important;
        }
        .id_card_2_bouton_1:active {
            background-color: ${id_card_2_bouton_1CouleurFondActive} !important;
            color: ${id_card_2_bouton_1CouleurTexteActive} !important;
            border-color: ${id_card_2_bouton_1CouleurBordureActive} !important;
        }
        .id_card_3_bouton_1:hover {
            background-color: ${id_card_3_bouton_1CouleurFondHover} !important;
            color: ${id_card_3_bouton_1CouleurTexteHover} !important;
            border-color: ${id_card_3_bouton_1CouleurBordureHover} !important;
        }
        .id_card_3_bouton_1:active {
            background-color: ${id_card_3_bouton_1CouleurFondActive} !important;
            color: ${id_card_3_bouton_1CouleurTexteActive} !important;
            border-color: ${id_card_3_bouton_1CouleurBordureActive} !important;
        }`}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="sous-titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_soustitre_1Afficher}
                        onChange={(val) => setAttributes({ id_soustitre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_soustitre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_soustitre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_soustitre_1Opacite}
                        onChange={(val) => setAttributes({ id_soustitre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icon-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_icon_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_icon_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_1_icon_1Alt}
                            onChange={(val) => setAttributes({ id_card_1_icon_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_icon_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_icon_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_1_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_1_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_1_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_1_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-1 (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_bouton_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_bouton_1Afficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_card_1_bouton_1Url}
                            onChange={(url) => setAttributes({ id_card_1_bouton_1Url: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_card_1_bouton_1CouleurFond} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_card_1_bouton_1CouleurTexte} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_card_1_bouton_1CouleurBordure} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_card_1_bouton_1CouleurFondHover} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_card_1_bouton_1CouleurTexteHover} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_card_1_bouton_1CouleurBordureHover} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_card_1_bouton_1CouleurFondActive} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_card_1_bouton_1CouleurTexteActive} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_card_1_bouton_1CouleurBordureActive} onChange={(val) => setAttributes({ id_card_1_bouton_1CouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_bouton_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_bouton_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_bouton_1_texteAfficher}
                        onChange={(val) => setAttributes({ id_card_1_bouton_1_texteAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_1_bouton_1_texteCouleurTexte}
                            onChange={(val) => setAttributes({ id_card_1_bouton_1_texteCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_bouton_1_texteOpacite}
                        onChange={(val) => setAttributes({ id_card_1_bouton_1_texteOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icon-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_icon_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_icon_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_2_icon_1Alt}
                            onChange={(val) => setAttributes({ id_card_2_icon_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_icon_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_icon_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_2_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_2_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_2_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_2_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-1 (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_bouton_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_bouton_1Afficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_card_2_bouton_1Url}
                            onChange={(url) => setAttributes({ id_card_2_bouton_1Url: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_card_2_bouton_1CouleurFond} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_card_2_bouton_1CouleurTexte} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_card_2_bouton_1CouleurBordure} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_card_2_bouton_1CouleurFondHover} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_card_2_bouton_1CouleurTexteHover} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_card_2_bouton_1CouleurBordureHover} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_card_2_bouton_1CouleurFondActive} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_card_2_bouton_1CouleurTexteActive} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_card_2_bouton_1CouleurBordureActive} onChange={(val) => setAttributes({ id_card_2_bouton_1CouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_bouton_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_bouton_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_bouton_1_texteAfficher}
                        onChange={(val) => setAttributes({ id_card_2_bouton_1_texteAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_2_bouton_1_texteCouleurTexte}
                            onChange={(val) => setAttributes({ id_card_2_bouton_1_texteCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_bouton_1_texteOpacite}
                        onChange={(val) => setAttributes({ id_card_2_bouton_1_texteOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icon-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_icon_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_icon_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_3_icon_1Alt}
                            onChange={(val) => setAttributes({ id_card_3_icon_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_icon_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_icon_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_3_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_3_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_3_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_3_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-1 (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_bouton_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_bouton_1Afficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_card_3_bouton_1Url}
                            onChange={(url) => setAttributes({ id_card_3_bouton_1Url: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_card_3_bouton_1CouleurFond} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_card_3_bouton_1CouleurTexte} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_card_3_bouton_1CouleurBordure} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_card_3_bouton_1CouleurFondHover} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_card_3_bouton_1CouleurTexteHover} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_card_3_bouton_1CouleurBordureHover} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_card_3_bouton_1CouleurFondActive} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_card_3_bouton_1CouleurTexteActive} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_card_3_bouton_1CouleurBordureActive} onChange={(val) => setAttributes({ id_card_3_bouton_1CouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_bouton_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_bouton_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_bouton_1_texteAfficher}
                        onChange={(val) => setAttributes({ id_card_3_bouton_1_texteAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_3_bouton_1_texteCouleurTexte}
                            onChange={(val) => setAttributes({ id_card_3_bouton_1_texteCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_bouton_1_texteOpacite}
                        onChange={(val) => setAttributes({ id_card_3_bouton_1_texteOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                {/* id_titre_1 */}
                {id_titre_1Afficher && (
                    <RichText 
                        tagName="h1" 
                        className="id_titre_1 " 
                        value={id_titre_1Texte} 
                        onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                    />
                )}
                {/* end-id_titre_1 */}
                {/* id_soustitre_1 */}
                {id_soustitre_1Afficher && (
                    <RichText 
                        tagName="h2" 
                        className="id_soustitre_1 " 
                        value={id_soustitre_1Texte} 
                        onChange={(val) => setAttributes({ id_soustitre_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_soustitre_1CouleurTexte, opacity: id_soustitre_1Opacite }} 
                    />
                )}
                {/* end-id_soustitre_1 */}
                {/* id_paragraphe_1 */}
                {id_paragraphe_1Afficher && (
                    <RichText 
                        tagName="p" 
                        className="id_paragraphe_1 " 
                        value={id_paragraphe_1Texte} 
                        onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                    />
                )}
                {/* end-id_paragraphe_1 */}
                <div className="row">
                    {/* id_card_1 */}
                    <div className="col-12 col-lg-4">
                        {/* id_card_1_icon_1 */}
                        {id_card_1_icon_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_card_1_icon_1Id: media.id, id_card_1_icon_1Alt: media.alt })}
                                type="image"
                                value={id_card_1_icon_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_card_1_icon_1ImageUrl ? (
                                            <img className="id_card_1_icon_1" src={id_card_1_icon_1ImageUrl} alt={id_card_1_icon_1Alt} style={{ opacity: id_card_1_icon_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_card_1_icon_1 */}
                        {/* id_card_1_titre_1 */}
                        {id_card_1_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_1_titre_1 " 
                                value={id_card_1_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_1_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_1_titre_1CouleurTexte, opacity: id_card_1_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_1_titre_1 */}
                        {/* id_card_1_paragraphe_1 */}
                        {id_card_1_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_1_paragraphe_1 " 
                                value={id_card_1_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_1_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_1_paragraphe_1CouleurTexte, opacity: id_card_1_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_1_paragraphe_1 */}
                        {/* id_card_1_bouton_1 */}
                        {id_card_1_bouton_1Afficher && (
                            <a 
                                className="btn id_card_1_bouton_1"
                                role="button"
                                onClick={(e) => e.preventDefault()}
                                style={{
                                    backgroundColor: id_card_1_bouton_1CouleurFond,
                                    color: id_card_1_bouton_1CouleurTexte,
                                    borderColor: id_card_1_bouton_1CouleurBordure,
                                    opacity: id_card_1_bouton_1Opacite,
                                    cursor: 'default'
                                }}
                            >
                                <RichText
                                    tagName="span"
                                    value={id_card_1_bouton_1Texte}
                                    onChange={(val) => setAttributes({ id_card_1_bouton_1Texte: val })}
                                    placeholder="Texte du bouton..."
                                />
                            </a>
                        )}
                        {/* end-id_card_1_bouton_1 */}
                    </div>
                    {/* end-id_card_1 */}
                    {/* id_card_2 */}
                    <div className="col-12 col-lg-4">
                        {/* id_card_2_icon_1 */}
                        {id_card_2_icon_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_card_2_icon_1Id: media.id, id_card_2_icon_1Alt: media.alt })}
                                type="image"
                                value={id_card_2_icon_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_card_2_icon_1ImageUrl ? (
                                            <img className="id_card_2_icon_1" src={id_card_2_icon_1ImageUrl} alt={id_card_2_icon_1Alt} style={{ opacity: id_card_2_icon_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_card_2_icon_1 */}
                        {/* id_card_2_titre_1 */}
                        {id_card_2_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_2_titre_1 " 
                                value={id_card_2_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_2_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_2_titre_1CouleurTexte, opacity: id_card_2_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_2_titre_1 */}
                        {/* id_card_2_paragraphe_1 */}
                        {id_card_2_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_2_paragraphe_1 " 
                                value={id_card_2_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_2_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_2_paragraphe_1CouleurTexte, opacity: id_card_2_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_2_paragraphe_1 */}
                        {/* id_card_2_bouton_1 */}
                        {id_card_2_bouton_1Afficher && (
                            <a 
                                className="btn id_card_2_bouton_1"
                                role="button"
                                onClick={(e) => e.preventDefault()}
                                style={{
                                    backgroundColor: id_card_2_bouton_1CouleurFond,
                                    color: id_card_2_bouton_1CouleurTexte,
                                    borderColor: id_card_2_bouton_1CouleurBordure,
                                    opacity: id_card_2_bouton_1Opacite,
                                    cursor: 'default'
                                }}
                            >
                                <RichText
                                    tagName="span"
                                    value={id_card_2_bouton_1Texte}
                                    onChange={(val) => setAttributes({ id_card_2_bouton_1Texte: val })}
                                    placeholder="Texte du bouton..."
                                />
                            </a>
                        )}
                        {/* end-id_card_2_bouton_1 */}
                    </div>
                    {/* end-id_card_2 */}
                    {/* id_card_3 */}
                    <div className="col-12 col-lg-4">
                        {/* id_card_3_icon_1 */}
                        {id_card_3_icon_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_card_3_icon_1Id: media.id, id_card_3_icon_1Alt: media.alt })}
                                type="image"
                                value={id_card_3_icon_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_card_3_icon_1ImageUrl ? (
                                            <img className="id_card_3_icon_1" src={id_card_3_icon_1ImageUrl} alt={id_card_3_icon_1Alt} style={{ opacity: id_card_3_icon_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_card_3_icon_1 */}
                        {/* id_card_3_titre_1 */}
                        {id_card_3_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_3_titre_1 " 
                                value={id_card_3_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_3_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_3_titre_1CouleurTexte, opacity: id_card_3_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_3_titre_1 */}
                        {/* id_card_3_paragraphe_1 */}
                        {id_card_3_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_3_paragraphe_1 " 
                                value={id_card_3_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_3_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_3_paragraphe_1CouleurTexte, opacity: id_card_3_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_3_paragraphe_1 */}
                        {/* id_card_3_bouton_1 */}
                        {id_card_3_bouton_1Afficher && (
                            <a 
                                className="btn id_card_3_bouton_1"
                                role="button"
                                onClick={(e) => e.preventDefault()}
                                style={{
                                    backgroundColor: id_card_3_bouton_1CouleurFond,
                                    color: id_card_3_bouton_1CouleurTexte,
                                    borderColor: id_card_3_bouton_1CouleurBordure,
                                    opacity: id_card_3_bouton_1Opacite,
                                    cursor: 'default'
                                }}
                            >
                                <RichText
                                    tagName="span"
                                    value={id_card_3_bouton_1Texte}
                                    onChange={(val) => setAttributes({ id_card_3_bouton_1Texte: val })}
                                    placeholder="Texte du bouton..."
                                />
                            </a>
                        )}
                        {/* end-id_card_3_bouton_1 */}
                    </div>
                    {/* end-id_card_3 */}
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}